import { MJ_APIKEY_PUBLIC, MJ_APIKEY_PRIVATE } from "../../../config/config";

export const sendClaimEmail = async ({ requestBody, navigate, setLoading }) => {
  try {
    setLoading(true);

    const response = await fetch("/api/sendEmail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ requestBody, type: "claim" }),
    });

    if (!response.ok) {
      throw new Error(`Email send failed: ${response.status}`);
    }

    const result = await response.json();
    console.log("Claim email sent successfully:", result);
  } catch (error) {
    console.error("Error sending claim email:", error);
    navigate(`/error?message=${encodeURIComponent(error.message)}`);
  } finally {
    setLoading(false);
  }
};

export const postCase = async ({ requestBody, navigate, setLoading }) => {
  const url = "/api/postCase";

  try {
    if (!requestBody.policyNumber) {
      throw new Error(
        "You're not logged in, please click retry to login and then proceed."
      );
    }

    setLoading(true);

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const responseData = await response.json();

    if (!response.ok) {
      throw new Error(`API call failed with status ${response.status}`);
    }

    if (responseData?.status === 500) {
      navigate(`/error?message=Internal Server Error`);
      return;
    }

    return responseData;
  } catch (error) {
    console.error("Error saving quote:", error);
    navigate(`/error?message=${encodeURIComponent(error.message)}`);
  } finally {
    setLoading(false);
  }
};

export const formatData = (formValues) => {
  return `\n\n${Object.entries(formValues)
    .map(([key, value]) =>
      key === "title" ? `\n\n\n${value}` : `\n\n${key}: \n${value}`
    )
    .join("")}`;
};
